import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { buildHttpParams } from '@app/shared/utils/query.utils';

import { ApiPaginatedResponseDto, ApiResponseDto } from '../common-dtos';
import {
  ImGroupAddDeviceRequestDto,
  ImGroupCreateRequestDto,
  ImGroupDevicesResponseDto,
  ImGroupDto,
  ImGroupFindRequestDto,
  ImGroupUpdateRequestDto,
} from './dtos';

@Injectable({ providedIn: 'root' })
export class ImGroupApiService {
  private readonly http = inject(HttpClient);

  public create(request: ImGroupCreateRequestDto): Observable<ImGroupDto> {
    return this.http.post<ApiResponseDto<ImGroupDto>>('/v1/groups', request).pipe(map((response) => response.data));
  }

  public find(request: ImGroupFindRequestDto): Observable<ApiPaginatedResponseDto<ImGroupDto>> {
    return this.http
      .get<ApiResponseDto<ApiPaginatedResponseDto<ImGroupDto>>>('/v1/groups', {
        params: buildHttpParams(request),
      })
      .pipe(map((response) => response.data));
  }

  public update(groupId: string, request: ImGroupUpdateRequestDto): Observable<ImGroupDto> {
    return this.http
      .patch<ApiResponseDto<ImGroupDto>>(`/v1/groups/${groupId}`, request)
      .pipe(map((response) => response.data));
  }

  public delete(groupId: string): Observable<unknown> {
    return this.http.delete(`/v1/groups/${groupId}`);
  }

  public findOne(groupId: string): Observable<ImGroupDto | null> {
    return this.http
      .get<ApiResponseDto<ImGroupDto | null>>(`/v1/groups/${groupId}`)
      .pipe(map((response) => response.data));
  }

  public getGroupDevices(groupId: string): Observable<ImGroupDevicesResponseDto> {
    return this.http
      .get<ApiResponseDto<ImGroupDevicesResponseDto>>(`/v1/groups/${groupId}/devices`)
      .pipe(map((response) => response.data));
  }

  public addGroupDevice(groupId: string, request: ImGroupAddDeviceRequestDto): Observable<unknown> {
    return this.http.post(`/v1/groups/${groupId}/devices`, request);
  }

  public deleteGroupDevice(groupId: string, deviceId: string): Observable<unknown> {
    return this.http.delete(`/v1/groups/${groupId}/devices/${deviceId}`);
  }
}
